var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page",
      attrs: {
        id: "Dataset",
        "data-page": "dataset",
        "data-taxhavens-selected": _vm.selectedTaxHavens
      }
    },
    [
      _c("div", { attrs: { id: "MobileExpandedMap" } }, [
        _c("div", {
          staticClass: "expanded_closebt",
          on: {
            click: function($event) {
              return _vm.closeExpandedMap()
            }
          }
        }),
        _c("div", { staticClass: "expanded_instructions" }, [
          _vm._v(
            "\n            Drag to navigate, pinch to zoom in/out\n        "
          )
        ]),
        _c("div", { staticClass: "map_container" })
      ]),
      _c("div", { attrs: { id: "MobileBottomFixed" } }),
      _c(
        "div",
        {
          class: _vm.citationModalDisplayed ? "displayed" : "",
          attrs: { id: "CiteModalWrapper" }
        },
        [
          _c("div", {
            attrs: { id: "CiteModalBg" },
            on: {
              click: function($event) {
                return _vm.closeCitationModal()
              }
            }
          }),
          _c("div", { attrs: { id: "CiteModal" } }, [
            _c("div", {
              staticClass: "modal_closebt",
              on: {
                click: function($event) {
                  return _vm.closeCitationModal()
                }
              }
            }),
            _c("div", { staticClass: "modal_title" }, [
              _vm._v("How to cite ?")
            ]),
            _c("div", {
              staticClass: "modal_text",
              domProps: { innerHTML: _vm._s(_vm.citationModalText) }
            }),
            _c("div", { staticClass: "modal_buttons" }, [
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "text" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("text")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [_vm._v("Copy text")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "apa" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("apa")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [_vm._v("Copy APA")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "bip" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("bip")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [
                    _vm._v("Copy BipTex")
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        ref: "appHeaderRef",
        attrs: {
          bgColor: "blue",
          page: "dataset",
          stickyTitle: _vm.datasetParams.label
        },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _c(
        "div",
        {
          class: _vm.stickyFiltersExpanded ? "expanded" : "",
          attrs: { id: "StickyFilters" },
          on: {
            click: function($event) {
              _vm.showMapModal = false
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "stickyfilters_bt",
              on: {
                click: function($event) {
                  return _vm.toggleMobileFilters()
                }
              }
            },
            [
              !_vm.stickyFiltersExpanded
                ? _c("span", [_vm._v("Change filters")])
                : _c("span", [_vm._v("Close filters")])
            ]
          ),
          _c("div", { staticClass: "stickyfilters_content" }, [
            _vm.hasTaxHavensData
              ? _c(
                  "div",
                  {
                    staticClass: "section_row mapcontrols_toggler app_toggler",
                    class: _vm.togglerFreezed ? "freezed" : "",
                    attrs: {
                      "data-selected": _vm.selectedTaxHavens ? "on" : "off"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "toggler_wrapper",
                        attrs: { "data-dataset": _vm.datasetID }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "toggler_label first",
                            class: !_vm.selectedTaxHavens ? "selected" : "",
                            on: {
                              click: function($event) {
                                return _vm.toggleTaxHavens()
                              }
                            }
                          },
                          [
                            _vm.datasetID == "global-profit"
                              ? _c("span", [_vm._v("Lost")])
                              : _vm.datasetID == "offshore-financial"
                              ? _c("span", [_vm._v("Owned")])
                              : _vm._e()
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "toggler_toggle",
                            on: {
                              click: function($event) {
                                return _vm.toggleTaxHavens()
                              }
                            }
                          },
                          [_c("div", { staticClass: "toggle_chip" })]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "toggler_label second",
                            class: _vm.selectedTaxHavens ? "selected" : "",
                            on: {
                              click: function($event) {
                                return _vm.toggleTaxHavens()
                              }
                            }
                          },
                          [
                            _vm.datasetID == "global-profit"
                              ? _c("span", [_vm._v("Won")])
                              : _vm.datasetID == "offshore-financial"
                              ? _c("span", [_vm._v("Hosted")])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.datasetIndicators.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "section_row row_filters",
                    attrs: { "data-align": "left" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "content_filter" },
                      [
                        _c("div", { staticClass: "filter_label" }, [
                          _vm._v("Indicator")
                        ]),
                        _c("v-select", {
                          staticClass: "actionblock_selectbox app_selectbox",
                          attrs: {
                            items: _vm.datasetIndicators,
                            "return-object": true,
                            label: "Choose an indicator",
                            solo: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(data) {
                                  return [
                                    _c("div", { staticClass: "item_wrapper" }, [
                                      _c("div", { staticClass: "item_text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.truncateSelectboxItem(
                                              data.item.label
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function(data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item_wrapper",
                                        attrs: { "data-item": data.item.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item_text" },
                                          [
                                            _c("span", {
                                              staticClass: "item_icon"
                                            }),
                                            _vm._v(_vm._s(data.item.label))
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            619319307
                          ),
                          model: {
                            value: _vm.selectedIndicator,
                            callback: function($$v) {
                              _vm.selectedIndicator = $$v
                            },
                            expression: "selectedIndicator"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.datasetID == "global-profit" && !_vm.selectedTaxHavens
                      ? _c(
                          "div",
                          { staticClass: "content_filter" },
                          [
                            _c("div", { staticClass: "filter_label" }, [
                              _vm._v("Counterpart")
                            ]),
                            _c("v-select", {
                              staticClass:
                                "actionblock_selectbox app_selectbox",
                              attrs: {
                                items: _vm.datasetCounterparts,
                                "return-object": true,
                                label: "Choose a counterpart",
                                solo: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "item_wrapper" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item_text" },
                                              [_vm._v(_vm._s(data.item.label))]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item_wrapper",
                                            attrs: { "data-item": data.item.id }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item_text" },
                                              [
                                                _c("span", {
                                                  staticClass: "item_icon"
                                                }),
                                                _vm._v(_vm._s(data.item.label))
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2334049676
                              ),
                              model: {
                                value: _vm.selectedCounterpart,
                                callback: function($$v) {
                                  _vm.selectedCounterpart = $$v
                                },
                                expression: "selectedCounterpart"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "content_filter" },
                      [
                        _c("div", { staticClass: "filter_label" }, [
                          _vm._v("Region")
                        ]),
                        _c("v-select", {
                          staticClass: "actionblock_selectbox app_selectbox",
                          attrs: {
                            items: _vm.DBRegions,
                            "return-object": true,
                            label: "Choose a region",
                            solo: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(data) {
                                  return [
                                    _c("div", { staticClass: "item_wrapper" }, [
                                      _c("div", { staticClass: "item_text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.truncateSelectboxItem(
                                              data.item.label
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function(data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item_wrapper",
                                        attrs: { "data-item": data.item.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item_text" },
                                          [
                                            _c("span", {
                                              staticClass: "item_icon"
                                            }),
                                            _vm._v(_vm._s(data.item.label))
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            619319307
                          ),
                          model: {
                            value: _vm.selectedRegion,
                            callback: function($$v) {
                              _vm.selectedRegion = $$v
                            },
                            expression: "selectedRegion"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "content_filter" },
                      [
                        _c("div", { staticClass: "filter_label" }, [
                          _vm._v("Income level")
                        ]),
                        _c("v-select", {
                          staticClass: "actionblock_selectbox app_selectbox",
                          attrs: {
                            items: _vm.DBIncomeLevels,
                            "return-object": true,
                            label: "Choose an income level",
                            solo: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(data) {
                                  return [
                                    _c("div", { staticClass: "item_wrapper" }, [
                                      _c("div", { staticClass: "item_text" }, [
                                        _vm._v(_vm._s(data.item.label))
                                      ])
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "item",
                                fn: function(data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "item_wrapper",
                                        attrs: { "data-item": data.item.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item_text" },
                                          [
                                            _c("span", {
                                              staticClass: "item_icon"
                                            }),
                                            _vm._v(_vm._s(data.item.label))
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2334049676
                          ),
                          model: {
                            value: _vm.selectedIncomeLevel,
                            callback: function($$v) {
                              _vm.selectedIncomeLevel = $$v
                            },
                            expression: "selectedIncomeLevel"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      ),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          {
            staticClass: "main_loader loader lds-ellipsis",
            class: _vm.mainLoaderDisplayed ? "displayed" : ""
          },
          [_c("div"), _c("div"), _c("div"), _c("div")]
        ),
        _c(
          "div",
          {
            staticClass: "main_inner",
            class: _vm.mainLoaderDisplayed ? "opacified" : ""
          },
          [
            _c(
              "section",
              {
                staticClass: "main_section",
                on: {
                  click: function($event) {
                    _vm.showMapModal = false
                  }
                }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _c("h2", { staticClass: "subtitle_page text_subtitle" }, [
                    _vm._v("Datasets")
                  ]),
                  _vm.DBDatasetTexts.title != undefined
                    ? _c(
                        "h1",
                        {
                          staticClass: "title_page text_title2",
                          staticStyle: { "margin-top": "10px" }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.DBDatasetTexts.title) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "app_button2 navigation_bt",
                      on: {
                        click: function($event) {
                          return _vm.openModal("dataset")
                        }
                      }
                    },
                    [_vm._v("Change dataset")]
                  ),
                  _vm.DBDatasetTexts.description != undefined &&
                  _vm.datasetID != "offshore-financial"
                    ? _c(
                        "p",
                        {
                          staticClass: "text_p",
                          staticStyle: { "margin-top": "14px" }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.DBDatasetTexts.description) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.datasetID != ""
                    ? _c(
                        "div",
                        {
                          staticClass: "page_infographic",
                          class: _vm.infographicExpanded ? "expanded" : "",
                          attrs: { "data-dataset": _vm.datasetID }
                        },
                        [
                          _c("div", { staticClass: "infographic_image" }, [
                            _c("img", {
                              staticClass: "image_bg",
                              attrs: {
                                src:
                                  "/images/infographic-" +
                                  _vm.datasetID +
                                  ".jpg"
                              }
                            })
                          ]),
                          _c("div", { staticClass: "more_actionbar" }, [
                            _c(
                              "div",
                              {
                                staticClass: "actionbar_bt",
                                on: {
                                  click: function($event) {
                                    _vm.infographicExpanded = !_vm.infographicExpanded
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.infographicExpanded
                                      ? "Close infographic"
                                      : "Expand infographic"
                                  )
                                )
                              ]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "actionbar_bt download",
                                attrs: {
                                  download: "",
                                  href:
                                    "/images/infographic-" +
                                    _vm.datasetID +
                                    ".jpg",
                                  download: ""
                                }
                              },
                              [_vm._v("Download infographic")]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _c(
              "section",
              {
                staticClass: "main_section section_mapcontrols",
                on: {
                  click: function($event) {
                    _vm.showMapModal = false
                  }
                }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _vm._m(0),
                  _vm.hasTaxHavensData
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "section_row mapcontrols_toggler app_toggler",
                          class: _vm.togglerFreezed ? "freezed" : "",
                          attrs: {
                            "data-selected": _vm.selectedTaxHavens
                              ? "on"
                              : "off"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "toggler_wrapper",
                              attrs: { "data-dataset": _vm.datasetID }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "toggler_label first",
                                  class: !_vm.selectedTaxHavens
                                    ? "selected"
                                    : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleTaxHavens()
                                    }
                                  }
                                },
                                [
                                  _vm.datasetID == "global-profit"
                                    ? _c("span", [_vm._v("Lost")])
                                    : _vm.datasetID == "offshore-financial"
                                    ? _c("span", [_vm._v("Owned")])
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "toggler_toggle",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleTaxHavens()
                                    }
                                  }
                                },
                                [_c("div", { staticClass: "toggle_chip" })]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "toggler_label second",
                                  class: _vm.selectedTaxHavens
                                    ? "selected"
                                    : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleTaxHavens()
                                    }
                                  }
                                },
                                [
                                  _vm.datasetID == "global-profit"
                                    ? _c("span", [_vm._v("Won")])
                                    : _vm.datasetID == "offshore-financial"
                                    ? _c("span", [_vm._v("Hosted")])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.DBDatasetTexts.Tax_haven_definition != undefined &&
                  _vm.DBDatasetTexts.Tax_haven_definition != ""
                    ? _c("div", { staticClass: "section_row" }, [
                        _vm.DBDatasetTexts.Tax_haven_definition != undefined
                          ? _c(
                              "span",
                              { staticClass: "text_maxwidthed bolder" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.DBDatasetTexts.Tax_haven_definition
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.datasetIndicators.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "section_row row_filters",
                          attrs: { id: "MobileFilters" }
                        },
                        [
                          _c("div", { staticClass: "content_filter" }, [
                            _c("div", { staticClass: "filter_label" }, [
                              _vm._v("Indicator")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "mobilefilters_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.forceShowMobileFilters()
                                  }
                                }
                              },
                              [_vm._v("Filters")]
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.datasetIndicators.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "section_row row_filters",
                          attrs: { id: "MapFilters", "data-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "content_filter" },
                            [
                              _c("div", { staticClass: "filter_label" }, [
                                _vm._v("Indicator")
                              ]),
                              _c("v-select", {
                                staticClass:
                                  "actionblock_selectbox app_selectbox",
                                attrs: {
                                  items: _vm.datasetIndicators,
                                  "return-object": true,
                                  label: "Choose an indicator",
                                  solo: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "item_wrapper" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.truncateSelectboxItem(
                                                        data.item.label
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item_wrapper",
                                              attrs: {
                                                "data-item": data.item.id
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _c("span", {
                                                    staticClass: "item_icon"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  619319307
                                ),
                                model: {
                                  value: _vm.selectedIndicator,
                                  callback: function($$v) {
                                    _vm.selectedIndicator = $$v
                                  },
                                  expression: "selectedIndicator"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.datasetID == "global-profit" &&
                          !_vm.selectedTaxHavens
                            ? _c(
                                "div",
                                { staticClass: "content_filter" },
                                [
                                  _c("div", { staticClass: "filter_label" }, [
                                    _vm._v("Counterpart")
                                  ]),
                                  _c("v-select", {
                                    staticClass:
                                      "actionblock_selectbox app_selectbox",
                                    attrs: {
                                      items: _vm.datasetCounterparts,
                                      "return-object": true,
                                      label: "Choose a counterpart",
                                      solo: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "item_wrapper" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item_text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(data.item.label)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "item_wrapper",
                                                  attrs: {
                                                    "data-item": data.item.id
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item_text"
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass: "item_icon"
                                                      }),
                                                      _vm._v(
                                                        _vm._s(data.item.label)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2334049676
                                    ),
                                    model: {
                                      value: _vm.selectedCounterpart,
                                      callback: function($$v) {
                                        _vm.selectedCounterpart = $$v
                                      },
                                      expression: "selectedCounterpart"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "content_filter" },
                            [
                              _c("div", { staticClass: "filter_label" }, [
                                _vm._v("Region")
                              ]),
                              _c("v-select", {
                                staticClass:
                                  "actionblock_selectbox app_selectbox",
                                attrs: {
                                  items: _vm.DBRegions,
                                  "return-object": true,
                                  label: "Choose a region",
                                  solo: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "item_wrapper" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.truncateSelectboxItem(
                                                        data.item.label
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item_wrapper",
                                              attrs: {
                                                "data-item": data.item.id
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _c("span", {
                                                    staticClass: "item_icon"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  619319307
                                ),
                                model: {
                                  value: _vm.selectedRegion,
                                  callback: function($$v) {
                                    _vm.selectedRegion = $$v
                                  },
                                  expression: "selectedRegion"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "content_filter" },
                            [
                              _c("div", { staticClass: "filter_label" }, [
                                _vm._v("Income level")
                              ]),
                              _c("v-select", {
                                staticClass:
                                  "actionblock_selectbox app_selectbox",
                                attrs: {
                                  items: _vm.DBIncomeLevels,
                                  "return-object": true,
                                  label: "Choose an income level",
                                  solo: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "item_wrapper" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item_wrapper",
                                              attrs: {
                                                "data-item": data.item.id
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item_text" },
                                                [
                                                  _c("span", {
                                                    staticClass: "item_icon"
                                                  }),
                                                  _vm._v(
                                                    _vm._s(data.item.label)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2334049676
                                ),
                                model: {
                                  value: _vm.selectedIncomeLevel,
                                  callback: function($$v) {
                                    _vm.selectedIncomeLevel = $$v
                                  },
                                  expression: "selectedIncomeLevel"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _c(
              "section",
              {
                staticClass: "main_section",
                attrs: {
                  id: "Wrapper_map",
                  "data-taxhavens": _vm.selectedTaxHavens ? "true" : "false"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "section_content section_map nopad" },
                  [
                    _vm.DBDatasetTexts.Map_title_default != undefined
                      ? _c("div", { staticClass: "map_title" }, [
                          !_vm.selectedTaxHavens
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.DBDatasetTexts.Map_title_default)
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.DBDatasetTexts.Map_title_tax_haven)
                                )
                              ])
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "mapwrapper_container",
                        class: !_vm.mapHasData ? "notdisplayed" : ""
                      },
                      [
                        _vm.datasetParams.label != undefined
                          ? _c("div", { staticClass: "map_legend" }, [
                              _c("div", { staticClass: "legend_title" }, [
                                _vm.selectedIndicator.id != "corp_tax_lost"
                                  ? _c("div", { staticClass: "title_item" }, [
                                      _vm.selectedIndicator.subtitleLabel !=
                                      undefined
                                        ? _c(
                                            "div",
                                            { staticClass: "title_indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedIndicator
                                                    .subtitleLabel
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "title_indicator" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedIndicator.label
                                                )
                                              )
                                            ]
                                          ),
                                      _vm.hasTaxHavensData
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "title_taxhavens",
                                              attrs: {
                                                "data-taxhavens": _vm.selectedTaxHavens
                                                  ? "true"
                                                  : ""
                                              }
                                            },
                                            [
                                              !_vm.selectedTaxHavens &&
                                              _vm.datasetID == "global-profit"
                                                ? _c("span", [_vm._v("lost")])
                                                : _vm.selectedTaxHavens &&
                                                  _vm.datasetID ==
                                                    "global-profit"
                                                ? _c("span", [_vm._v("won")])
                                                : !_vm.selectedTaxHavens &&
                                                  _vm.datasetID ==
                                                    "offshore-financial"
                                                ? _c("span", [_vm._v("owned")])
                                                : _vm.selectedTaxHavens &&
                                                  _vm.datasetID ==
                                                    "offshore-financial"
                                                ? _c("span", [_vm._v("hosted")])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  : _c("div", { staticClass: "title_item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "title_indicator" },
                                        [
                                          _vm._v(
                                            "\n                                        Corporate tax revenue\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm.hasTaxHavensData
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "title_taxhavens",
                                              attrs: {
                                                "data-taxhavens": _vm.selectedTaxHavens
                                                  ? "true"
                                                  : ""
                                              }
                                            },
                                            [
                                              !_vm.selectedTaxHavens &&
                                              _vm.datasetID == "global-profit"
                                                ? _c("span", [_vm._v("lost")])
                                                : _vm.selectedTaxHavens &&
                                                  _vm.datasetID ==
                                                    "global-profit"
                                                ? _c("span", [_vm._v("won")])
                                                : !_vm.selectedTaxHavens &&
                                                  _vm.datasetID ==
                                                    "offshore-financial"
                                                ? _c("span", [_vm._v("owned")])
                                                : _vm.selectedTaxHavens &&
                                                  _vm.datasetID ==
                                                    "offshore-financial"
                                                ? _c("span", [_vm._v("hosted")])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "title_indicator" },
                                        [
                                          _vm._v(
                                            "\n                                        as a share of corporate tax revenue collected\n                                    "
                                          )
                                        ]
                                      )
                                    ]),
                                _vm.selectedIndicator.homeUnit != undefined
                                  ? _c("div", { staticClass: "title_unit" }, [
                                      _vm._v(
                                        " (in " +
                                          _vm._s(
                                            _vm.selectedIndicator.homeUnit
                                          ) +
                                          ")"
                                      )
                                    ])
                                  : _c("div", { staticClass: "title_unit" }, [
                                      _vm._v(
                                        " (in " +
                                          _vm._s(_vm.selectedIndicator.unit) +
                                          ")"
                                      )
                                    ]),
                                _vm.datasetID == "global-profit" &&
                                !_vm.selectedTaxHavens
                                  ? _c("div", { staticClass: "title_sep" }, [
                                      _vm._v("|")
                                    ])
                                  : _vm._e(),
                                _vm.datasetID == "global-profit" &&
                                !_vm.selectedTaxHavens
                                  ? _c("div", { staticClass: "title_sep" }, [
                                      _vm._v(
                                        "\n                                    Counterpart: " +
                                          _vm._s(
                                            _vm.selectedCounterpart.label
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "title_sep" }, [
                                  _vm._v("|")
                                ]),
                                _c("div", { staticClass: "title_param" }, [
                                  _vm._v(
                                    "Region: " +
                                      _vm._s(_vm.selectedRegion.label)
                                  )
                                ]),
                                _c("div", { staticClass: "title_sep" }, [
                                  _vm._v("|")
                                ]),
                                _c("div", { staticClass: "title_param" }, [
                                  _vm._v(_vm._s(_vm.selectedIncomeLevel.label))
                                ]),
                                _c("div", { staticClass: "title_sep" }, [
                                  _vm._v("|")
                                ]),
                                _c("div", { staticClass: "title_param" }, [
                                  _vm._v(_vm._s(_vm.mapCurrentYear))
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "map_container",
                            attrs: {
                              "data-hasmodal": _vm.showMapModal
                                ? "true"
                                : "false"
                            }
                          },
                          [
                            _c("MapModal", {
                              attrs: {
                                countryTooltipData: _vm.countryTooltipData,
                                countriesMapData: _vm.countriesMapData,
                                datasetID: _vm.datasetID,
                                selectedYear: _vm.mapCurrentYear,
                                isShow: _vm.showMapModal,
                                countryDBDataset: _vm.mapModalCountryDBDataset,
                                countryDB: _vm.mapModalCountryDB,
                                DBEffectiveTax: _vm.DBEffectiveTax,
                                DBProfitShiftingTaxHavenTooltipData:
                                  _vm.DBProfitShiftingTaxHavenTooltipData,
                                indicatorObj: _vm.selectedIndicator,
                                counterpartObj: _vm.selectedCounterpart,
                                mapShowTaxHavens: _vm.selectedTaxHavens
                              },
                              on: { closeMapModal: _vm.handleCloseMapModal }
                            }),
                            _c("mapChoropleth", {
                              ref: "appMapRef",
                              attrs: {
                                mapData: _vm.countriesMapData,
                                indicatorUnit: _vm.indicatorUnit,
                                hasTaxHavensData: _vm.hasTaxHavensData,
                                hasTimeline: _vm.mapHasTimeline,
                                indicatorID: _vm.selectedIndicator.id,
                                selectedRegion: _vm.selectedRegion,
                                datasetID: _vm.datasetID,
                                displayWorldTotal: true
                              },
                              on: {
                                countryClicked: _vm.handleMapCountryClicked,
                                currentYear: _vm.callbackMapCurrentYear
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "map_expand_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.expandMap()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "bt" }, [
                                  _vm._v("Expand map")
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "content_downloadbar" }, [
                          _c("div", { staticClass: "downloadbar_wrapper" }, [
                            _c("div", { staticClass: "downloadbar_title" }, [
                              _vm._v("Download")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportXLS("map")
                                  }
                                }
                              },
                              [_vm._v("Dataset (.xslx)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt",
                                on: {
                                  click: function($event) {
                                    return _vm.exportGraphic("map", true)
                                  }
                                }
                              },
                              [_vm._v("Image (.png)")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "downloadbar_bt cite",
                                on: {
                                  click: function($event) {
                                    return _vm.displayCitationModal()
                                  }
                                }
                              },
                              [_vm._v("Cite")]
                            )
                          ])
                        ]),
                        _vm.DBDatasetTexts.Map_description != undefined
                          ? _c("div", { staticClass: "content_more" }, [
                              _c("div", { staticClass: "more_text" }, [
                                _vm.mapMoreExpanded
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.DBDatasetTexts.Map_description
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.truncate(
                                            _vm.DBDatasetTexts.Map_description
                                          )
                                        )
                                      )
                                    ])
                              ]),
                              _vm.DBDatasetTexts.Map_description.length >
                              _vm.mapMoreTextLimit
                                ? _c("div", { staticClass: "more_actionbar" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "actionbar_bt",
                                        on: {
                                          click: function($event) {
                                            _vm.mapMoreExpanded = !_vm.mapMoreExpanded
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.mapMoreExpanded
                                              ? "Collapse"
                                              : "Read More"
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    ),
                    _c("div", {
                      staticClass: "chart_nodatablock",
                      class: !_vm.mapHasData ? "displayed" : "notdisplayed"
                    })
                  ]
                )
              ]
            ),
            _vm.datasetID != "offshore-real-estate" &&
            _vm.datasetID != "offshore-financial"
              ? _c(
                  "section",
                  {
                    staticClass: "main_section section_chart",
                    attrs: { id: "Wrapper_timeseries" },
                    on: {
                      click: function($event) {
                        _vm.showMapModal = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "section_content" }, [
                      _vm.DBDatasetTexts.Timeseries_title != undefined
                        ? _c("div", { staticClass: "content_title" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.DBDatasetTexts.Timeseries_title) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "section_row" },
                        [
                          _c("div", { staticClass: "legend_title" }, [
                            _vm.selectedIndicator.id != "corp_tax_lost"
                              ? _c("div", { staticClass: "title_item" }, [
                                  _vm.selectedIndicator.subtitleLabel !=
                                  undefined
                                    ? _c(
                                        "div",
                                        { staticClass: "title_indicator" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.selectedIndicator
                                                .subtitleLabel
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "title_indicator" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.selectedIndicator.label)
                                          )
                                        ]
                                      ),
                                  _vm.hasTaxHavensData
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "title_taxhavens",
                                          attrs: {
                                            "data-taxhavens": _vm.selectedTaxHavens
                                              ? "true"
                                              : ""
                                          }
                                        },
                                        [
                                          !_vm.selectedTaxHavens &&
                                          _vm.datasetID == "global-profit"
                                            ? _c("span", [_vm._v("lost")])
                                            : _vm.selectedTaxHavens &&
                                              _vm.datasetID == "global-profit"
                                            ? _c("span", [_vm._v("won")])
                                            : !_vm.selectedTaxHavens &&
                                              _vm.datasetID ==
                                                "offshore-financial"
                                            ? _c("span", [_vm._v("owned")])
                                            : _vm.selectedTaxHavens &&
                                              _vm.datasetID ==
                                                "offshore-financial"
                                            ? _c("span", [_vm._v("hosted")])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _c("div", { staticClass: "title_item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title_indicator" },
                                    [
                                      _vm._v(
                                        "\n                                    Corporate tax revenue\n                                "
                                      )
                                    ]
                                  ),
                                  _vm.hasTaxHavensData
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "title_taxhavens",
                                          attrs: {
                                            "data-taxhavens": _vm.selectedTaxHavens
                                              ? "true"
                                              : ""
                                          }
                                        },
                                        [
                                          !_vm.selectedTaxHavens &&
                                          _vm.datasetID == "global-profit"
                                            ? _c("span", [_vm._v("lost")])
                                            : _vm.selectedTaxHavens &&
                                              _vm.datasetID == "global-profit"
                                            ? _c("span", [_vm._v("won")])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "title_indicator" },
                                    [
                                      _vm._v(
                                        "\n                                    as a share of corporate tax revenue collected\n                                "
                                      )
                                    ]
                                  )
                                ]),
                            _vm.selectedIndicator.homeUnit != undefined
                              ? _c("div", { staticClass: "title_unit" }, [
                                  _vm._v(
                                    " (in " +
                                      _vm._s(_vm.selectedIndicator.homeUnit) +
                                      ")"
                                  )
                                ])
                              : _c("div", { staticClass: "title_unit" }, [
                                  _vm._v(
                                    " (in " +
                                      _vm._s(_vm.selectedIndicator.unit) +
                                      ")"
                                  )
                                ]),
                            _vm.datasetID == "global-profit" &&
                            !_vm.selectedTaxHavens
                              ? _c("div", { staticClass: "title_sep" }, [
                                  _vm._v("|")
                                ])
                              : _vm._e(),
                            _vm.datasetID == "global-profit" &&
                            !_vm.selectedTaxHavens
                              ? _c("div", { staticClass: "title_sep" }, [
                                  _vm._v(
                                    "\n                                Counterpart: " +
                                      _vm._s(_vm.selectedCounterpart.label) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "title_sep" }, [
                              _vm._v("|")
                            ]),
                            _c("div", { staticClass: "title_param" }, [
                              _vm._v(
                                "Region: " + _vm._s(_vm.selectedRegion.label)
                              )
                            ]),
                            _c("div", { staticClass: "title_sep" }, [
                              _vm._v("|")
                            ]),
                            _c("div", { staticClass: "title_param" }, [
                              _vm._v(_vm._s(_vm.selectedIncomeLevel.label))
                            ])
                          ]),
                          _vm.timeseriesHasData
                            ? _c("highchartsTimeSeries", {
                                attrs: {
                                  timeSeriesData: _vm.timeseriesData,
                                  timeSeriesCategories:
                                    _vm.timeseriesCategories,
                                  indicatorUnit: _vm.indicatorUnit,
                                  indicatorLabel: _vm.indicatorLabel,
                                  minY:
                                    _vm.datasetID == "global-profit" ? 0 : null
                                }
                              })
                            : _c("div", { staticClass: "chart_nodatablock" })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "content_downloadbar" }, [
                        _c("div", { staticClass: "downloadbar_wrapper" }, [
                          _c("div", { staticClass: "downloadbar_title" }, [
                            _vm._v("Download")
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "downloadbar_bt",
                              on: {
                                click: function($event) {
                                  return _vm.exportXLS("timeseries")
                                }
                              }
                            },
                            [_vm._v("Dataset (.xslx)")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "downloadbar_bt",
                              on: {
                                click: function($event) {
                                  return _vm.exportGraphic("timeseries")
                                }
                              }
                            },
                            [_vm._v("Image (.png)")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "downloadbar_bt cite",
                              on: {
                                click: function($event) {
                                  return _vm.displayCitationModal()
                                }
                              }
                            },
                            [_vm._v("Cite")]
                          )
                        ])
                      ]),
                      _vm.DBDatasetTexts.Timeseries_description != undefined
                        ? _c("div", { staticClass: "content_more" }, [
                            _c("div", { staticClass: "more_text" }, [
                              _vm.timeseriesMoreExpanded
                                ? _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.DBDatasetTexts
                                            .Timeseries_description
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.truncate(
                                          _vm.DBDatasetTexts
                                            .Timeseries_description
                                        )
                                      )
                                    )
                                  ])
                            ]),
                            _vm.DBDatasetTexts.Timeseries_description.length >
                            _vm.mapMoreTextLimit
                              ? _c("div", { staticClass: "more_actionbar" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "actionbar_bt",
                                      on: {
                                        click: function($event) {
                                          _vm.timeseriesMoreExpanded = !_vm.timeseriesMoreExpanded
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.timeseriesMoreExpanded
                                            ? "Collapse"
                                            : "Read More"
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              : _vm._e(),
            _vm.datasetID == "offshore-financial"
              ? _c(
                  "section",
                  {
                    staticClass: "main_section section_chart",
                    attrs: { id: "Wrapper_area" },
                    on: {
                      click: function($event) {
                        _vm.showMapModal = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "section_content" }, [
                      _vm.DBDatasetTexts.Timeseries_title != undefined
                        ? _c("div", { staticClass: "content_title" }, [
                            _vm._v(_vm._s(_vm.DBDatasetTexts.Timeseries_title))
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "section_row" },
                        [
                          _c("div", { staticClass: "area_legend" }, [
                            _c("div", { staticClass: "legend_title" }, [
                              _vm.selectedIndicator.id != "corp_tax_lost"
                                ? _c("div", { staticClass: "title_item" }, [
                                    _vm.selectedIndicator.subtitleLabel !=
                                    undefined
                                      ? _c(
                                          "div",
                                          { staticClass: "title_indicator" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedIndicator
                                                  .subtitleLabel
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "title_indicator" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedIndicator.label
                                              )
                                            )
                                          ]
                                        ),
                                    _vm.hasTaxHavensData
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "title_taxhavens",
                                            attrs: {
                                              "data-taxhavens": _vm.selectedTaxHavens
                                                ? "true"
                                                : ""
                                            }
                                          },
                                          [
                                            !_vm.selectedTaxHavens &&
                                            _vm.datasetID == "global-profit"
                                              ? _c("span", [_vm._v("lost")])
                                              : _vm.selectedTaxHavens &&
                                                _vm.datasetID == "global-profit"
                                              ? _c("span", [_vm._v("won")])
                                              : !_vm.selectedTaxHavens &&
                                                _vm.datasetID ==
                                                  "offshore-financial"
                                              ? _c("span", [_vm._v("owned")])
                                              : _vm.selectedTaxHavens &&
                                                _vm.datasetID ==
                                                  "offshore-financial"
                                              ? _c("span", [_vm._v("hosted")])
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _c("div", { staticClass: "title_item" }, [
                                    _c(
                                      "div",
                                      { staticClass: "title_indicator" },
                                      [
                                        _vm._v(
                                          "\n                                        Corporate tax revenue\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm.hasTaxHavensData
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "title_taxhavens",
                                            attrs: {
                                              "data-taxhavens": _vm.selectedTaxHavens
                                                ? "true"
                                                : ""
                                            }
                                          },
                                          [
                                            !_vm.selectedTaxHavens &&
                                            _vm.datasetID == "global-profit"
                                              ? _c("span", [_vm._v("lost")])
                                              : _vm.selectedTaxHavens &&
                                                _vm.datasetID == "global-profit"
                                              ? _c("span", [_vm._v("won")])
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "title_indicator" },
                                      [
                                        _vm._v(
                                          "\n                                        as a share of corporate tax revenue collected\n                                    "
                                        )
                                      ]
                                    )
                                  ]),
                              _vm.selectedIndicator.homeUnit != undefined
                                ? _c("div", { staticClass: "title_unit" }, [
                                    _vm._v(
                                      " (in " +
                                        _vm._s(_vm.selectedIndicator.homeUnit) +
                                        ")"
                                    )
                                  ])
                                : _c("div", { staticClass: "title_unit" }, [
                                    _vm._v(
                                      " (in " +
                                        _vm._s(_vm.selectedIndicator.unit) +
                                        ")"
                                    )
                                  ]),
                              _c("div", { staticClass: "title_sep" }, [
                                _vm._v("|")
                              ]),
                              _c("div", { staticClass: "title_param" }, [
                                _vm._v(
                                  "Region: " + _vm._s(_vm.selectedRegion.label)
                                )
                              ]),
                              _c("div", { staticClass: "title_sep" }, [
                                _vm._v("|")
                              ]),
                              _c("div", { staticClass: "title_param" }, [
                                _vm._v(_vm._s(_vm.selectedIncomeLevel.label))
                              ])
                            ])
                          ]),
                          _vm.areaHasData
                            ? _c("highchartsAreaChart", {
                                attrs: {
                                  areaChartData: _vm.areaChartData,
                                  areaChartCategories: _vm.areaChartCategories,
                                  indicatorUnit: _vm.indicatorUnit,
                                  indicatorLabel: _vm.indicatorLabel
                                }
                              })
                            : _c("div", { staticClass: "chart_nodatablock" })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "content_downloadbar" }, [
                        _c("div", { staticClass: "downloadbar_wrapper" }, [
                          _c("div", { staticClass: "downloadbar_title" }, [
                            _vm._v("Download")
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "downloadbar_bt",
                              on: {
                                click: function($event) {
                                  return _vm.exportXLS("area")
                                }
                              }
                            },
                            [_vm._v("Dataset (.xslx)")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "downloadbar_bt",
                              on: {
                                click: function($event) {
                                  return _vm.exportGraphic("area")
                                }
                              }
                            },
                            [_vm._v("Image (.png)")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "downloadbar_bt cite",
                              on: {
                                click: function($event) {
                                  return _vm.displayCitationModal()
                                }
                              }
                            },
                            [_vm._v("Cite")]
                          )
                        ])
                      ]),
                      _vm.DBDatasetTexts.Timeseries_description != undefined
                        ? _c("div", { staticClass: "content_more" }, [
                            _c("div", { staticClass: "more_text" }, [
                              _vm.timeseriesMoreExpanded
                                ? _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.DBDatasetTexts
                                            .Timeseries_description
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.truncate(
                                          _vm.DBDatasetTexts
                                            .Timeseries_description
                                        )
                                      )
                                    )
                                  ])
                            ]),
                            _vm.DBDatasetTexts.Timeseries_description.length >
                            _vm.mapMoreTextLimit
                              ? _c("div", { staticClass: "more_actionbar" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "actionbar_bt",
                                      on: {
                                        click: function($event) {
                                          _vm.timeseriesMoreExpanded = !_vm.timeseriesMoreExpanded
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.timeseriesMoreExpanded
                                            ? "Collapse"
                                            : "Read More"
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "section",
              {
                staticClass: "main_section section_chart",
                on: {
                  click: function($event) {
                    _vm.showMapModal = false
                  }
                }
              },
              [
                _c("div", { staticClass: "section_content" }, [
                  _vm.DBDatasetTexts.Ranking_title != undefined
                    ? _c("div", { staticClass: "content_title" }, [
                        _vm.datasetID == "offshore-financial" &&
                        !_vm.selectedTaxHavens
                          ? _c("span", [
                              _vm._v(
                                "\n                            Which countries own most offshore financial wealth?\n                        "
                              )
                            ])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.DBDatasetTexts.Ranking_title))
                            ])
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "legend_title",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _vm.selectedIndicator.id != "corp_tax_lost"
                        ? _c("div", { staticClass: "title_item" }, [
                            _vm.selectedIndicator.subtitleLabel != undefined
                              ? _c("div", { staticClass: "title_indicator" }, [
                                  _vm._v(
                                    _vm._s(_vm.selectedIndicator.subtitleLabel)
                                  )
                                ])
                              : _c("div", { staticClass: "title_indicator" }, [
                                  _vm._v(_vm._s(_vm.selectedIndicator.label))
                                ]),
                            _vm.hasTaxHavensData
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "title_taxhavens",
                                    attrs: {
                                      "data-taxhavens": _vm.selectedTaxHavens
                                        ? "true"
                                        : ""
                                    }
                                  },
                                  [
                                    !_vm.selectedTaxHavens &&
                                    _vm.datasetID == "global-profit"
                                      ? _c("span", [_vm._v("lost")])
                                      : _vm.selectedTaxHavens &&
                                        _vm.datasetID == "global-profit"
                                      ? _c("span", [_vm._v("won")])
                                      : !_vm.selectedTaxHavens &&
                                        _vm.datasetID == "offshore-financial"
                                      ? _c("span", [_vm._v("owned")])
                                      : _vm.selectedTaxHavens &&
                                        _vm.datasetID == "offshore-financial"
                                      ? _c("span", [_vm._v("hosted")])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _c("div", { staticClass: "title_item" }, [
                            _c("div", { staticClass: "title_indicator" }, [
                              _vm._v(
                                "\n                                Corporate tax revenue\n                            "
                              )
                            ]),
                            _vm.hasTaxHavensData
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "title_taxhavens",
                                    attrs: {
                                      "data-taxhavens": _vm.selectedTaxHavens
                                        ? "true"
                                        : ""
                                    }
                                  },
                                  [
                                    !_vm.selectedTaxHavens &&
                                    _vm.datasetID == "global-profit"
                                      ? _c("span", [_vm._v("lost")])
                                      : _vm.selectedTaxHavens &&
                                        _vm.datasetID == "global-profit"
                                      ? _c("span", [_vm._v("won")])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "title_indicator" }, [
                              _vm._v(
                                "\n                                as a share of corporate tax revenue collected\n                            "
                              )
                            ])
                          ]),
                      _vm.selectedIndicator.homeUnit != undefined
                        ? _c("div", { staticClass: "title_unit" }, [
                            _vm._v(
                              " (in " +
                                _vm._s(_vm.selectedIndicator.homeUnit) +
                                ")"
                            )
                          ])
                        : _c("div", { staticClass: "title_unit" }, [
                            _vm._v(
                              " (in " + _vm._s(_vm.selectedIndicator.unit) + ")"
                            )
                          ]),
                      _vm.datasetID == "global-profit" && !_vm.selectedTaxHavens
                        ? _c("div", { staticClass: "title_sep" }, [_vm._v("|")])
                        : _vm._e(),
                      _vm.datasetID == "global-profit" && !_vm.selectedTaxHavens
                        ? _c("div", { staticClass: "title_sep" }, [
                            _vm._v(
                              "\n                            Counterpart: " +
                                _vm._s(_vm.selectedCounterpart.label) +
                                "\n                        "
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "title_sep" }, [_vm._v("|")]),
                      _c("div", { staticClass: "title_param" }, [
                        _vm._v("Region: " + _vm._s(_vm.selectedRegion.label))
                      ]),
                      _c("div", { staticClass: "title_sep" }, [_vm._v("|")]),
                      _c("div", { staticClass: "title_param" }, [
                        _vm._v(_vm._s(_vm.selectedIncomeLevel.label))
                      ])
                    ]
                  ),
                  _c("div", { staticClass: "content_col col_ranking" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ranking_container",
                        class: !_vm.rankingHasData ? "notdisplayed" : ""
                      },
                      [
                        _c("rankingGraph", {
                          attrs: {
                            rankingData: _vm.countriesRankingData,
                            indicatorUnit: _vm.indicatorUnit,
                            hasTimeline: _vm.rankingHasTimeline,
                            sortingOrder: _vm.rankingSortingOrder
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", {
                      staticClass: "chart_nodatablock",
                      class: !_vm.rankingHasData ? "displayed" : "notdisplayed"
                    })
                  ]),
                  _c("div", { staticClass: "content_col col_ranking_text" }, [
                    _vm.DBDatasetTexts.Ranking_description != undefined
                      ? _c("p", { staticClass: "text_p" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.DBDatasetTexts.Ranking_description) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            ),
            _vm.datasetID == "offshore-real-estate"
              ? _c(
                  "section",
                  {
                    staticClass: "main_section section_bubbles",
                    attrs: { id: "Wrapper_barchart" },
                    on: {
                      click: function($event) {
                        _vm.showMapModal = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "section_content" }, [
                      _vm.DBDatasetTexts.City_title != undefined
                        ? _c("div", { staticClass: "content_title" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.DBDatasetTexts.City_title) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "bubble_container",
                          class: !_vm.bubbleHasData ? "notdisplayed" : ""
                        },
                        [
                          _vm.selectedIndicator.id != "pctGDP"
                            ? _c(
                                "div",
                                { staticClass: "content_row" },
                                [
                                  _c("bubblesGraph", {
                                    attrs: {
                                      bubblesData: _vm.sortedCitiesData,
                                      indicatorUnit: " B$"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("div", { staticClass: "content_row" }, [
                                _c("p", { staticClass: "text_p" }, [
                                  _vm._v(
                                    "Switch the indicator to find additional data on offshore real estate at the city level"
                                  )
                                ])
                              ])
                        ]
                      ),
                      _c("div", {
                        staticClass: "chart_nodatablock",
                        class: !_vm.bubbleHasData ? "displayed" : "notdisplayed"
                      })
                    ])
                  ]
                )
              : _vm._e()
          ]
        )
      ]),
      _c("appFooter", { on: { headerMenuClicked: _vm.menuClicked } }),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "section_hr", attrs: { id: "HRIndicatorFilters" } },
      [
        _c("div", { staticClass: "hr_text dataset" }, [
          _vm._v("INDICATOR FILTERS")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f88a6c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f88a6c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dataset/_datasetID.vue
// module id = gZZ4
// module chunks = 0